// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { evmosTestnet as _evmosTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the evmosTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 9000
 * Chain Name: Evmos Testnet
 * Default Block Explorer: https://evm.evmos.dev/
 * Default RPC URL: https://eth.bd.evmos.dev:8545
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { evmosTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: evmosTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const evmosTestnet = createCommon({
	..._evmosTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
